import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Likes from '../components/Likes';

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

function mapDispatchToProps() {
  return {};
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Likes));



// WEBPACK FOOTER //
// ./src/components/Steps/Likes/container/index.js